/* eslint-disable @typescript-eslint/ban-ts-comment */
import { utils } from "@febos-io/common";
import { Filtrable } from '../../types/list';

export const getDocumentList = (type, page, limit = 1, sort = '-createdAt', filter = undefined) => ({
  path: `v1/documents/${type}`,
  params: {
    page,
    limit,
    sort,
    // @ts-ignore
    ...{ ...(filter && { filter }) }
  }
});

export const findDocumentList = (
  type,
  page,
  limit = 1,
  sort: string | undefined = '-createdAt',
  filter = undefined
) => ({
  path: `v1/tools/search/${type}`,
  params: {
    pagina: page,
    elementosPorPagina: limit,
    orden: sort,
    // @ts-ignore
    ...{ ...(filter && { filtros: filter }) }
  }
});

export type SaveDocumentProps = {
  status?: string;
  dentist?: string;
  medicalCenter?: string;
  patient?: string;
  technician?: string;
  urgency?: string;
  medicalDiagnosis?: string;
  observations?: string;
  company?: string;
  exams?: string[];
  caseToApi?: string;
  isControl?: boolean;
};

export const findOrdertList = (page, limit = 1, sort = '-createdAt', filter = undefined) => ({
  path: '/v1/documents/dental-order/buscar',
  params: {
    pagina: page,
    elementosPorPagina: limit,
    orden: sort,
    // @ts-ignore
    ...{ ...(filter && { filtros: filter }) }
  }
});

export const findExamtList = (page, limit = 1, sort = '-createdAt', filter = undefined) => ({
  path: '/v1/documents/dental-exam/buscar',
  params: {
    pagina: page,
    elementosPorPagina: limit,
    orden: sort,
    // @ts-ignore
    ...{ ...(filter && { filtros: filter }) }
  }
});

export const saveDocument = (
  type,
  {
    status,
    dentist,
    medicalCenter,
    patient,
    technician,
    urgency,
    medicalDiagnosis,
    observations,
    company,
    exams,
    caseToApi,
    isControl
  }: SaveDocumentProps = {},
  printer = false
) => ({
  path: `v1/documents/${type}?imprimir=${printer ? 'si' : 'no'}`,
  method: utils.METHOD.POST,
  content: {
    status,
    dentist,
    medicalCenter,
    patient,
    technician,
    urgency,
    medicalDiagnosis,
    observations,
    company,
    isControl,
    exams,
    case: caseToApi
  }
});

export const correctDocument = (type, examId, exam = {}) => ({
  path: `v1/documents/${type}/${examId}/correct`,
  method: utils.METHOD.POST,
  content: exam
});

export const rejectDocument = (type, examId) => ({
  path: `v1/documents/${type}/${examId}/reject`,
  method: utils.METHOD.POST
});

export const cancelDocument = (type, examId, message, user) => ({
  path: `v1/documents/${type}/${examId}`,
  method: utils.METHOD.DELETE,
  content: {
    message,
    user
  }
});
export const requestReportDocument = (type, examId, medicalDiagnosis) => ({
  path: `v1/documents/${type}/${examId}/inform/request`,
  method: utils.METHOD.POST,
  content: {
    medicalDiagnosis
  }
});

export const updateDocument = (
  type,
  orderId,
  {
    status,
    dentist,
    medicalCenter,
    patient,
    technician,
    urgency,
    medicalDiagnosis,
    observations,
    company,
    exams,
    caseToApi
  }
) => ({
  path: `v1/documents/${type}/${orderId}`,
  method: utils.METHOD.PUT,
  content: {
    status,
    dentist,
    medicalCenter,
    patient,
    technician,
    urgency,
    medicalDiagnosis,
    observations,
    company,
    exams,
    case: caseToApi
  }
});

export const getDocument = (type, id) => ({
  path: `v1/documents/${type}/${id}`
});

export const reportDocument = (type, id, { report, filesReport, radiologist, status }) => ({
  path: `v1/documents/${type}/${id}/inform`,
  method: utils.METHOD.POST,
  params: {
    status
  },
  content: {
    report,
    filesReport,
    radiologist
  }
});

export const getPersonDocument = (type, id) => ({
  path: `v1/person/me/${type}/${id}`
});

export const getConsentFormList = (companyId, page, filter) => ({
  path: `/v1/companies/${companyId}/settings/documents/consent-form`,
  params: {
    pagina: page,
    // @ts-ignore
    ...{ ...(filter && { filtros: filter }) }
  }
});

export const getVersions = (companyId, idConfig) => ({
  path: `/v1/companies/${companyId}/settings/documents/consent-form/${idConfig}/version`
});

export const activateVersion = (companyId, idTemplate, version) => ({
  path: `/v1/companies/${companyId}/settings/documents/consent-form/${idTemplate}/version`,
  method: utils.METHOD.PUT,
  content: {
    version: version
  }
});

export const publishConfig = (companyId, idTemplate) => ({
  path: `/v1/companies/${companyId}/settings/documents/consent-form/${idTemplate}/version/publish`,
  method: utils.METHOD.POST
});

export const getConsentFormById = (companyId, id, version) => ({
  path: `/v1/companies/${companyId}/settings/documents/consent-form/${id}?version=${version}`
});

export const saveConsentForm = (companyId, data) => ({
  path: `/v1/companies/${companyId}/settings/documents/consent-form`,
  method: utils.METHOD.POST,
  content: {
    ...data
  }
});

export const editConsentForm = (companyId, data, id) => ({
  path: `/v1/companies/${companyId}/settings/documents/consent-form/${id}`,
  method: utils.METHOD.PUT,
  content: {
    ...data
  }
});

export const toggleStatus = (companyId, id) => ({
  path: `/v1/companies/${companyId}/settings/documents/consent-form/${id}`,
  method: utils.METHOD.PUT,
  content: {
    action: 'toggle-status'
  }
});

export const getTariffs = ({ page, limit, filter = undefined }:Filtrable) => ({
  path: `/v1/settings/tariffs`,
  method: utils.METHOD.GET,
  params: {
    page,
    limit,
    // @ts-ignore
    ...{ ...(filter && { filter: filter }) }
  }
});

export const saveTariff = ({ name }) => ({
  path: `/v1/settings/tariffs`,
  method: utils.METHOD.POST,
  content: {
    name
  }
});

export const editTariff = ({ name, id_tariff }) => ({
  path: `/v1/settings/tariffs/${id_tariff}`,
  method: utils.METHOD.PATCH,
  content: {
    name
  }
});

export const getCategoriesByTariff = ({ tariffId, page, limit, filter = undefined }) => ({
  path: `/v1/settings/tariffs/${tariffId}/categories`,
  method: utils.METHOD.GET,
  params: {
    page,
    limit,
    // @ts-ignore
    ...{ ...(filter && { filter: filter }) }
  }
});

export const saveCategoryByTariff = ({ companyId, tariffId, name }) => ({
  path: `/v1/settings/tariffs/${tariffId}/categories`,
  method: utils.METHOD.POST,
  content: {
    name
  }
});

export const editCategory = ({ companyId, categoryId, name }) => ({
  path: `/v1/companies/${companyId}/settings/provisions/categories/${categoryId}`,
  method: utils.METHOD.PATCH,
  content: {
    name
  }
});

export const getProvisionsByTariffAndCategory = ({ companyId, filter = undefined, page, limit }) => ({
  path: `/v1/companies/${companyId}/settings/provisions`,
  method: utils.METHOD.GET,
  params: {
    page,
    limit,
    // @ts-ignore
    ...{ ...(filter && { filter: filter }) }
  }
});

export const saveNewProvision = ({ companyId, tariffId, category, provision, clinicId = '0' }) => ({
  path: `/v1/companies/${companyId}/settings/provisions`,
  method: utils.METHOD.POST,
  content: {
    tariffId,
    categoryId: category,
    provision,
    clinicId
  }
});

export const updateProvision = ({ companyId, tariffId, category, provision, idProvision }) => ({
  path: `/v1/companies/${companyId}/settings/provisions/${idProvision}`,
  method: utils.METHOD.PATCH,
  content: {
    tariffId,
    categoryId: category,
    provision
  }
});

export const toggleStatusProvision = ({ companyId, idProvision }) => ({
  path: `/v1/companies/${companyId}/settings/provisions/${idProvision}`,
  method: utils.METHOD.DELETE
});

export const toggleStatusTariff = ({ companyId, idTariff }) => ({
  path: `/v1/settings/tariffs/${idTariff}`,
  method: utils.METHOD.DELETE
});

export const toggleStatusCategory = ({ companyId, idCategory }) => ({
  path: `/v1/companies/${companyId}/settings/provisions/categories/${idCategory}`,
  method: utils.METHOD.DELETE
});

export const analizeExamWithIa = ({ id }: { id: string }) => ({
  path: `/v1/tools/velmeni/analyze`,
  params: {
    id
  }
});

export const saveNewRecordOfCarePatient = ({ companyId, patientId, data }) => ({
  path: `/v1/companies/${companyId}/patients/${patientId}/records-of-care`,
  method: utils.METHOD.POST,
  content: {
    ...data
  }
})

export const getRecordsOfCarePatient = ({ companyId, patientId, page, filter = undefined }) => ({
  path: `/v1/companies/${companyId}/patients/${patientId}/records-of-care`,
  method: utils.METHOD.GET,
  params: {
    page,
    // @ts-ignore
    ...{ ...(filter && { filter: filter }) }
  }
})

export const payRecordsOfCarePatient = ({ companyId, patientId, idRecord, amount }) => ({
  path: `/v1/companies/${companyId}/patients/${patientId}/records-of-care/${idRecord}/pay`,
  method: utils.METHOD.POST,
  content: {
    amount
  }
})

export const cancellRecordsOfCarePatient = ({ companyId, patientId, idRecord }) => ({
  path: `/v1/companies/${companyId}/patients/${patientId}/records-of-care/${idRecord}`,
  method: utils.METHOD.DELETE
})

export const cancelPayRecordsOfCarePatient = ({ companyId, patientId, idRecord, idPay }) => ({
  path: `/v1/companies/${companyId}/patients/${patientId}/records-of-care/${idRecord}/pay/${idPay}`,
  method: utils.METHOD.DELETE
})
